// extracted by mini-css-extract-plugin
module.exports = {"InfoBannerWebNotification":"WebPushNotificationsAutoPromptController_InfoBannerWebNotification__3JYy9"};